import { ToolbarItem } from '../interfaces/tool-bar-item.interface';
import { ViewControl } from './controls/view-control.model';
import { GridSettings } from '../interfaces/grid-settings.interface';

export abstract class BaseForm {

  name: string;
  formName: string;
  apiController: string;
  views: ViewControl[] = [];
  keyFieldName: string; // will be used as the value to pass in Detail URLs (ex. /Item/Detail/{keyFieldName}   where keyFieldName = Uniqnum)
  toolbarItems: ToolbarItem[] = [];
  breadCrumbPropertyNames: string[] = [];
  canFilterSearch: boolean;

  abstract initializeUiControls(): void;
  
}
